'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMetadata = exports.createMetadata = exports.fetchMetadata = exports.deserializeMetadata = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var deserializeMetadata = exports.deserializeMetadata = function deserializeMetadata() {
  var metadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return metadata.reduce(function (keys, _ref) {
    var key = _ref.key,
        value = _ref.value,
        id = _ref.id;
    return _extends({}, keys, _defineProperty({}, key, { id: id, value: value }));
  }, {});
};

var fetchMetadata = exports.fetchMetadata = function fetchMetadata(_ref2) {
  var _ref2$app = _ref2.app,
      app = _ref2$app === undefined ? (0, _params.required)() : _ref2$app,
      _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token,
      id = _ref2.id,
      _ref2$authType = _ref2.authType,
      authType = _ref2$authType === undefined ? 'Basic' : _ref2$authType;
  return _client.metadataAPI.get('/v1/apps/' + app + '/metadata', {
    params: { page: id },
    headers: { Authorization: [authType, token].join(' ') }
  }).then(function (response) {
    return response.data;
  });
};

var createMetadata = exports.createMetadata = function createMetadata(_ref3) {
  var _ref3$app = _ref3.app,
      app = _ref3$app === undefined ? (0, _params.required)() : _ref3$app,
      _ref3$token = _ref3.token,
      token = _ref3$token === undefined ? (0, _params.required)() : _ref3$token,
      _ref3$id = _ref3.id,
      id = _ref3$id === undefined ? (0, _params.required)() : _ref3$id,
      _ref3$metadata = _ref3.metadata,
      metadata = _ref3$metadata === undefined ? (0, _params.required)() : _ref3$metadata,
      _ref3$authType = _ref3.authType,
      authType = _ref3$authType === undefined ? 'Basic' : _ref3$authType;

  var headers = { Authorization: [authType, token].join(' ') };
  var values = (0, _keys2.default)(metadata).map(function (key) {
    return { key: key, value: metadata[key] };
  });

  return _client.metadataAPI.post('/v1/apps/' + app + '/metadata', { page: id, values: values }, { headers: headers }).then(function (response) {
    return response.data;
  });
};

var updateMetadata = exports.updateMetadata = function updateMetadata(_ref4) {
  var _ref4$app = _ref4.app,
      app = _ref4$app === undefined ? (0, _params.required)() : _ref4$app,
      _ref4$token = _ref4.token,
      token = _ref4$token === undefined ? (0, _params.required)() : _ref4$token,
      _ref4$id = _ref4.id,
      id = _ref4$id === undefined ? (0, _params.required)() : _ref4$id,
      _ref4$key = _ref4.key,
      key = _ref4$key === undefined ? (0, _params.required)() : _ref4$key,
      _ref4$value = _ref4.value,
      value = _ref4$value === undefined ? (0, _params.required)() : _ref4$value,
      _ref4$authType = _ref4.authType,
      authType = _ref4$authType === undefined ? 'Basic' : _ref4$authType;
  return _client.metadataAPI.put('/v1/apps/' + app + '/metadata/' + id, { key: key, value: value }, { headers: { Authorization: [authType, token].join(' ') } }).then(function (response) {
    return response.data;
  });
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/metadata/justgiving/index.js
// module id = 1330
// module chunks = 0